// extracted by mini-css-extract-plugin
module.exports = {"formNodata":"_1EvxsefrGODH4RHyMnUqwk","tableContainer":"_3TQtB1zrwcUgr8Oi7gOVjn"};